module.exports = __webpack_public_path__ + "img/syllabus-level2-line.ca43c7f1.png";